import { render, staticRenderFns } from "./country-language-details.vue?vue&type=template&id=1d537ef8&scoped=true&"
import script from "./country-language-details.vue?vue&type=script&lang=js&"
export * from "./country-language-details.vue?vue&type=script&lang=js&"
import style0 from "./country-language-details.vue?vue&type=style&index=0&id=1d537ef8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d537ef8",
  null
  
)

component.options.__file = "country-language-details.vue"
export default component.exports